import { EventEmitter } from "events";

import Swagger from "swagger-client";
import { checkStatus, errorHandler, errorHandlerLogin } from "./helpers";
import history from '../history'

class SessionStore extends EventEmitter {
  constructor() {
    super();
    this.client = null;
    this.user = null;
    this.organizations = [];
    this.settings = {};
    this.branding = {};
    
    this.swagger = Swagger("/swagger/internal.swagger.json", this.getClientOpts())

    this.swagger.then(client => {
      this.client = client;

      if (this.getToken() !== null) {
        this.fetchProfile(() => {});
      }
    });
  
    
  }

  getClientOpts() {
    return {
      requestInterceptor: (req) => {
        if (this.getToken() !== null) {
          req.headers["Grpc-Metadata-Authorization"] = "Bearer " + this.getToken();
        }
        return req;
      },
    }
  }

  setToken(token) {
    localStorage.setItem("jwt", token);
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getOrganizationID() {
    const orgID = localStorage.getItem("organizationID");
    if (orgID === "") {
      return null;
    }

    return orgID;
  }

  setOrganizationID(id) {
    localStorage.setItem("organizationID", id);
    this.emit("organization.change");
  }

  getRowsPerPage() {
    const rowsPerPage = localStorage.getItem("rowsPerPage");
    if (rowsPerPage === "" || rowsPerPage === null) {
      return 100;
    }

    return JSON.parse(rowsPerPage);
  }

  setRowsPerPage(rowsPerPage) {
    localStorage.setItem("rowsPerPage", JSON.stringify(rowsPerPage));
  }


  getPage() {
    const Page = localStorage.getItem("Page");
    if (Page === "" || Page === null) {
      return 1;
    }

    return JSON.parse(Page);
  }

  setCurrentPage(Page) {
    localStorage.setItem("Page", JSON.stringify(Page));
  }

  getSelectedFields(page){
    if(!page){
      return [];
    }
    const selectedFields = localStorage.getItem("selectedFields");

    if (selectedFields === "" || selectedFields === null) {
      this.setSelectedFields(page,[])
      return [];
    }
    let json = JSON.parse(selectedFields);
    if(!json[page]){
      return [];
    }

    return json[page];
  }
  setSelectedFields(page,fields){
    if(!page){
      return false;
    }

    let data = localStorage.getItem("selectedFields");
    if (data === "" || data === null) {
      data = {}
      data[page] = fields
    }else{
      data = JSON.parse(data)
      if(!data[page]){
        return false;
      }
      data[page] = fields;
    }
    localStorage.setItem("selectedFields", JSON.stringify(data) );
  }
  getUser() {
    return this.user;
  }

  getSettings() {
    return this.settings;
  }

  getMode(){
    return localStorage.getItem("authMode");
  }
  setMode(mode){
    if(mode===true){
      localStorage.setItem("authMode", "noauth" );
    }else{
      localStorage.removeItem("authMode")
    }

    this.emit("change");
  }
  isAdmin() {
    if (this.user === undefined || this.user === null) {
      return false;
    }
    return this.user.isAdmin;
  }

  isOrganizationAdmin(organizationID) {
    for (let i = 0; i < this.organizations.length; i++) {
      if (this.organizations[i].organizationID === organizationID) {
        return this.organizations[i].isAdmin;
      }
    }
  }

  isOrganizationDeviceAdmin(organizationID) {
    for (let i = 0; i < this.organizations.length; i++) {
      if (this.organizations[i].organizationID === organizationID) {
        return this.organizations[i].isAdmin || this.organizations[i].isDeviceAdmin;
      }
    }
  }

  isOrganizationGatewayAdmin(organizationID) {
    for (let i = 0; i < this.organizations.length; i++) {
      if (this.organizations[i].organizationID === organizationID) {
        return this.organizations[i].isAdmin || this.organizations[i].isGatewayAdmin;
      }
    }
  }

  organizationCanHaveGateways(organizationID) {
    for (let i = 0; i < this.organizations.length; i++) {
      if (this.organizations[i].organizationID === organizationID) {
        return this.organizations[i].canHaveGateways
      }
    }
  }

  login(login, callBackFunc,state) {
    this.swagger.then(client => {
      client.apis.InternalService.InternalService_Login({body: login})
        .then(checkStatus)
        .then(resp => {
          this.setToken(resp.obj.jwt);
          this.fetchProfile(callBackFunc);
        })
        .catch((error)=>{
          state.setState({spinner:false})
          errorHandlerLogin(error)
        });
    });
  }

  openidConnectLogin(code, state, callbackFunc) {
    this.swagger.then(client => {
      client.apis.InternalService.InternalService_OpenIDConnectLogin({
        code: code,
        state: state,
      })
        .then(checkStatus)
        .then(resp => {
          this.setToken(resp.obj.jwtToken);
          this.fetchProfile(callbackFunc);
        })
        .catch(errorHandler);
    });
  }

  logout(emit, callBackFunc) {
    localStorage.removeItem('jwt')
    localStorage.removeItem('organizationID')
    localStorage.removeItem('serverName')
    // localStorage.clear();
    this.user = null;
    this.organizations = [];
    this.settings = {};
    history.prevPage=''
    if (emit === true) {
      this.emit("change");
    }

    callBackFunc();
  }
  getQueryString(){
    let search = window.location.hash.split('?')[1];

    if (!search) {
      return  null
    }
    let obj ={ }
    let searchParams = new URLSearchParams(search);
    for(let i of searchParams){
  
      obj[ i[0] ] = i[1]
    }

   return obj ||  null
  }
  fetchProfile(callBackFunc) {
    this.fetchingProfile = true
    this.swagger.then(client => {
      client.apis.InternalService.InternalService_Profile({})
        .then(checkStatus)
        .then(resp => {
          this.user = resp.obj.user;

          if(resp.obj.organizations !== undefined) {
            this.organizations = resp.obj.organizations;
          }

          if(resp.obj.settings !== undefined) {
            this.settings = resp.obj.settings;
          }

          this.emit("change");
          this.emit("userGot");
          this.fetchingProfile = undefined
          callBackFunc();
        })
        .catch(errorHandler);
    });
  }

  globalSearch(search, limit, offset, callbackFunc) {
    this.swagger.then(client => {
      client.apis.InternalService.InternalService_GlobalSearch({
        search: search,
        limit: limit,
        offset: offset,
      })
      .then(checkStatus)
      .then(resp => {
        callbackFunc(resp.obj);
      })
      .catch(errorHandler);
      });
  }
}

const sessionStore = new SessionStore();
export default sessionStore;
